import { Model } from "@vuex-orm/core";
import Batch from "./Batch";
import RawMaterial from "./RawMaterial";
import { maxLength, decimal, required } from "vuelidate/lib/validators";

export class BatchMeasurement extends Model {
  static entity = 'batchmeasurements';

  static $fetch() {
    return this.api().get('BatchMeasurements/')
  }
  static $get (id) {
    return this.api().get(`BatchMeasurements/${id}/`)
  }
  static $post (data) {
    return this.api().post(`BatchMeasurements/`, data)
  }
  static $put (id, data) {
    return this.api().put(`BatchMeasurements/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`BatchMeasurements/${id}/`, data)
  }
  static $delete (id) {
    return this.api().delete(`BatchMeasurements/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      icp: this.number(0),
      icpIcon: this.string("fas fa-burn"),
      analyte: this.string("Al"),
      analyteIcon: this.string("fas fa-atom"),
      reagent: this.string("AR"),
      reagentIcon: this.string("fas fa-eye-dropper"),
      ppm_water: this.number(0),
      waterIcon: this.string("fas fa-tint"),
      bet: this.number(0),
      betIcon: this.string("fas fa-layer-group"),
      density: this.number(0),
      densityIcon: this.string("fas fa-fill"),
      created_on: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      lastmodified: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      note: this.string(""),
      noteIcon: this.string("mdi-message-bulleted"),
      batch: this.belongsTo(Batch, "batch_id"),
      batch_id: this.attr(null),
      run: this.string(""),
      runIcon: this.string("mdi-run")
    };
  }
  toCreatePayload() {
    return {
      icp: this.icp,
      analyte: this.analyte,
      reagent: this.reagent,
      ppm_water: this.ppm_water,
      bet: this.bet,
      density: this.density,
      note: this.note,
      batch: this.batch_id,
      run: this.run
    };
  }
  toUpdatePayload() {
    return {
      id: this.$id,
      ...this.toCreatePayload()
    };
  }
  static get validations() {
    return {
      formdata: {
        icp: { maxLength: maxLength(10), decimal },
        analyte: { maxLength: maxLength(16) },
        reagent: { maxLength: maxLength(16) },
        ppm_water: { maxLength: maxLength(10), decimal },
        bet: { maxLength: maxLength(10), decimal },
        density: { maxLength: maxLength(6), decimal },
        note: { maxLength: maxLength(500) },
        run: { required, maxLength: maxLength(16) }
      }
    };
  }
}


export class RawMeasurement extends Model {
  static entity = 'rawmeasurements';

  static $fetch() {
    return this.api().get('RawMeasurements/')
  }
  static $get (id) {
    return this.api().get(`RawMeasurements/${id}/`)
  }
  static $post (data) {
    return this.api().post(`RawMeasurements/`, data)
  }
  static $put (id, data) {
    return this.api().put(`RawMeasurements/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`RawMeasurements/${id}/`, data)
  }
  static $delete (id) {
    return this.api().delete(`BatchMeasurements/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      icp: this.number(0),
      icpIcon: this.string("fas fa-burn"),
      analyte: this.string("Al"),
      analyteIcon: this.string("fas fa-atom"),
      reagent: this.string("AR"),
      reagentIcon: this.string("fas fa-eye-dropper"),
      ppm_water: this.number(0),
      waterIcon: this.string("fas fa-tint"),
      bet: this.number(0),
      betIcon: this.string("fas fa-layer-group"),
      density: this.number(0),
      densityIcon: this.string("fas fa-fill"),
      created_on: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      lastmodified: this.string(new Date(), value =>
        new Date(value).toLocaleString()
      ),
      note: this.string(""),
      noteIcon: this.string("mdi-message-bulleted"),
      rawmaterial: this.belongsTo(RawMaterial, "rawmaterial_id"),
      rawmaterial_id: this.attr(null)
    };
  }
  toCreatePayload() {
    return {
      icp: this.icp,
      analyte: this.analyte,
      reagent: this.reagent,
      ppm_water: this.ppm_water,
      bet: this.bet,
      density: this.density,
      note: this.note,
      rawmaterial: this.rawmaterial_id,
      run: this.run
    };
  }
  toUpdatePayload() {
    return {
      id: this.$id,
      ...this.toCreatePayload()
    };
  }
  static get validations() {
    return {
      formdata: {
        icp: { maxLength: maxLength(10), decimal },
        analyte: { maxLength: maxLength(16) },
        reagent: { maxLength: maxLength(16) },
        ppm_water: { maxLength: maxLength(10), decimal },
        bet: { maxLength: maxLength(10), decimal },
        density: { maxLength: maxLength(6), decimal },
        note: { maxLength: maxLength(500) }
      }
    };
  }
}

